<template>
    <div>
        <div class="position-relative py-2" v-if="mode === 'edit'">
            <!--Select input-->
            <div class="input-group input-group-sm mb-1"
                 v-if="!isRangeableValue && isSelection">
                <div class="input-group-prepend">
                    <span class="input-group-text">{{selectedProp.name}}</span>
                </div>
                <select class="custom-select"  name="type" id="selectVal" v-model="val">
                    <option :key="option"
                            :value="option"
                            v-for="(option, index) in selProp.options">
                        {{option}}
                    </option>
                </select>
                <div class="input-group-append" v-if="selectedProp.help">
                    <css-help-tooltip :selected-prop="selectedProp"/>
                </div>
                <div class="input-group-append">
                    <span class="input-group-text input-group-delete"
                          @click="$emit('delete')">
                        X
                    </span>
                </div>
            </div>
            
            <!--Range input-->
            <div  v-else="isRangeableValue">
                <div class="input-group input-group-sm position-relative">
                    <div class="input-group-prepend">
                        <span class="input-group-text">{{selectedProp.name}}</span>
                    </div>
                    <input type="range" class="form-control m-0"
                           @keyup.stop="$utils.noop"
                           :min="minValue"
                           :max="maxValue"
                           v-model="val"
                           v-if="isRangeableValue && valueType !== ''">
                    <input type="text"
                           class="form-control"
                           @keyup.stop="$utils.noop"
                           v-model="val"
                           @focus="showPicker = true"
                           v-else>
                    <div class="color-picker"
                         v-if="selectedProp.showPicker && showPicker">
                        <div class="bg-danger text-white text-center"
                             @click="showPicker = false" key="delete">
                            {{$t('COMMON.close')}}
                        </div>
                        <color-picker v-model="val"></color-picker>
                    </div>
                    <div class="input-group-append"
                         :style="{'background-color': val, width: '50px'}"
                            v-if="selectedProp.showPicker">
                    </div>
                    <div class="input-group-append" v-if="selectedProp.help">
                        <css-help-tooltip :selected-prop="selectedProp"/>
                    </div>
                    <div class="input-group-append">
                        <span class="input-group-text input-group-delete"
                              @click="$emit('delete')" key="delete">X</span>
                    </div>
                </div>
                <div class="input-group input-group-sm" v-if="showUnits">
                    <div class="input-group-prepend">
                        <label class="input-group-text" for="valueType">
                            {{$t('LAYOUTEDITOR.valueAndUnit')}}
                        </label>
                    </div>
                    <input type="text"
                           class="form-control"
                           @keyup.delete.stop="() => {}"
                           v-model="val"
                           v-if="isRangeableValue && valueType !== ''">
                    <select class="custom-select"
                            name="type"
                            id="valueType"
                            v-model="valueType">
                        <option :value="''">none</option>
                        <option :value="'%'">%</option>
                        <option :value="'px'">px</option>
                    </select>
                </div>
            </div>
            <label for="scaled" v-if="showScale">scale
                <input id="scaled"
                       type="checkbox"
                       @change="handleScale" v-model="scaled">
            </label>
        </div>
        
        <div v-if="mode === 'add'" class="row">
            <div class="col-12 col-md-9">
                <multiselect v-model="selProp"
                             :options="cssPropsArr"
                             :close-on-select="true"
                             :hide-selected="true"
                             :preserve-search="true"
                             selectLabel=""
                             deselectLabel=""
                             placeholder="Css Property"
                             label="name"
                             trackBy="name" v-if="mode === 'add'">
                    <template slot="tag" slot-scope="props">
                    <span class="custom__tag">
                        <span>{{ props.option.name }}</span>
                        <span class="custom__remove"
                              @click="props.remove(props.option)">
                            ❌
                        </span>
                    </span>
                    </template>
                </multiselect>
            </div>
            <div class="col-12 col-md-3">
                <button class="btn btn-cph-primary-outline mt-0 mx-auto"
                        name="add style"
                        @click="$emit('addStyle', {prop: selectedProp.name, value: val})"
                        :disabled="!selectedProp.name" key="add" >
                    Add style
                </button>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">

import {cssPropsArr, getParsedCssProps} from '../../../../../../utilities/css/cssProperties';
import {mapGetters, mapMutations} from 'vuex';
import Sketch from 'vue-color/src/components/Sketch';
import CssHelpTooltip from './CssHelpTooltip';

export default {
    name: 'CssProp',
    data () {
        return {
            cssProps: getParsedCssProps(),
            cssPropsArr : cssPropsArr,
            scaled: false,
            valueType: '',
            showPicker: false
        };
    },
    props: {
        mode: {
            type: String,
            default: 'add'
        },
        newProperty: {
            type: Boolean,
            default: false
        },
        selectedProp: {
            type: [Object, Array],
            default: () => ({
                name: ''
            })
        },
        value: {
            type: [String, Array, Number],
            default: ''
        },
        isTemplate: {
            type: Boolean,
            default: false
        }
    },
    components: {
        CssHelpTooltip,
        ColorPicker: Sketch
    },
    computed: {
        ...mapGetters({
            rootPath : 'getEditedElementRootPath',
            currentLayout: 'getCurrentLayout',
            elementId: 'getEditedElementId'
        }),
        isSelection () {
            return this.selectedProp.type === 'select';
        },
        showUnits () {
            return this.selectedProp.showUnits;
        },
        selProp: {
            get () {
                return this.selectedProp;
            },
            set (newVal) {
                this.$emit('selectedProperty', newVal);
            }
        },
        isRangeableValue () {
            if(this.value && this.value.match) {
                return this.showUnits && this.value.match(new RegExp(/%|cm|mm|in|pc|px|pt/));
            } else {
                return false;
            }
        },
        rangeableValueType () {
            let valueType = this.isRangeableValue
                ? this.value.match(new RegExp(/%|cm|mm|in|pc|px|pt/))
                : null;
            return valueType ? valueType[0] : '';
        },
        minValue () {
            if(this.valueType === '%') {
                return -150;
            }   else {
                return -500;
            }
        },
        maxValue () {
            if(this.valueType === '%') {
                return 150;
            }   else {
                return 3000;
            }
        },
        val: {
            get () {
                return this.isRangeableValue
                    ? this.value.replace(/[^0-9|\-|.]+/g, '')
                    : this.value;
            },
            set (newValue) {
                if(typeof newValue === 'object') {
                    newValue = newValue.hex;
                }
                if(!this.isTemplate) {
                    if(!this.currentLayout.metadata.modifiedScalableValues) {
                        this.$vuexSet('currentLayout.metadata.modifiedScalableValues', []);
                    }
                    this.$vuexSet('currentLayout.metadata.modifiedScalableValues',
                        [...this.currentLayout.metadata.modifiedScalableValues,
                            this.scaledObject
                        ].filter(this.$utils.onlyUniqueItems));
                }
                this.$emit('newValue', {
                    prop: this.selectedProp.name,
                    value:  this.isRangeableValue ? newValue + this.valueType : newValue
                });
            }
        },
        scaledObject () {
            return {
                id: this.elementId,
                style: `${this.selectedProp.name}`
            };
        },
        scaledItemIndex () {
            if(this.currentLayout
                && this.currentLayout.metadata
                && this.currentLayout.metadata.scalableValues) {
                
                let {id, style} = this.scaledObject;
                return this.currentLayout.metadata.scalableValues.findIndex(element => element.id === id && element.style === style);
            }
        }
    },
    watch: {
        value: {
            handler: 'toggleShowScale',
            immediate: true
        },
        valueType (newValueType, oldValueType) {
            if(newValueType !== oldValueType) {
                let valueToSave = this.val;
                if(+this.val > this.maxValue) {
                    valueToSave = this.maxValue;
                }
                if(newValueType !== 'px') {
                    this.showScale = false;
                    this.scaled = false;
                    this.handleScale();
                } else {
                    this.showScale = true;
                    if(this.scaledItemIndex !== -1) {
                        this.scaled = true;
                    }
                }
                this.$emit('newValue', {
                    prop: this.selectedProp.name,
                    value:  valueToSave + newValueType
                });
            }
        },
        rangeableValueType (newVal) {
            if(newVal || newVal === '') {
                this.valueType = newVal;
            }
        }
    },
    methods: {
        ...mapMutations(['removeMetadataValue']),
        handleScale () {
            if(!this.currentLayout.metadata.scalableValues) {
                this.$vuexSet('currentLayout.metadata.scalableValues', []);
            }
            
            if(this.scaled) {
                if(this.scaledItemIndex !== -1) {
                    return;
                }
                this.$vuexSet('currentLayout.metadata.scalableValues',
                    [...this.currentLayout.metadata.scalableValues, this.scaledObject]);
            } else {
                if(this.scaledItemIndex > -1) {
                    this.removeMetadataValue({index: this.scaledItemIndex});
                }
            }
        },
        toggleShowScale (val) {
            let checkedValue = val || this.value;
            this.showScale = checkedValue ?
                checkedValue.match(new RegExp(/\d+(cm|mm|in|pc|px|pt)/g))
                : false;
        }
    },
    created () {
        if(this.scaledItemIndex !== -1) {
            this.scaled = true;
        }
    }
};

</script>

<style lang="scss" scoped>
    .input-group {
        .input-group-text, .input-group-value {
            font-size: 12px !important;
        }
        .input-group-delete {
            color: #dc3545;
        }
        [type='range'] {
            background: #fff !important;
        }
        select {
            max-height: 31px;
        }
    }
</style>
